module.exports = __webpack_public_path__ + "static/media/xbox.7c118796.svg";